module.exports = __webpack_public_path__ + "static/media/shadow.ce53aa41.png";